import "./Index.css"
import { faDiagramProject, faFilter, faPlus, faTag, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BoardItem from "./BoardItem";
import { useDispatch, useSelector } from "react-redux";
import { load as loadBoard } from '../../../reducers/models/board/boardList'
import { load as loadBoardTask, updatedBoardFalse, loadCheckList, loadListLabel, filterLabel, filterUser } from '../../../reducers/models/board/boardTaskList'
import { load as loadBoardProjectList, loadTransfer as loadBoardProjectTransfer, loadUser as loadBoardProjectUser } from '../../../reducers/models/board/boardProjectList'
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import FilterUniversal from "../../../components/filter/FilterUniversal";
import BoardModalAdd from "./BoardModalAdd";
import ProjectForUserObjectList from "../../../util/ProjectForUserObjectList";
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

    const idObject = 3;//Доски

    const dispatch = useDispatch()

    const refHeader = useRef(null);

    //Получаем данные из reducer
    const stateBoardList = useSelector((state) => state.boardList);
    const stateBoardTaskList = useSelector((state) => state.boardTaskList);
    const stateBoardProjectList = useSelector((state) => state.boardProjectList);//Связка проект-доска
    const stateSetting = useSelector((state) => state.setting);//Настройки
    const stateProject = useSelector((state) => state.projectList);
    const stateUserList = useSelector((state) => state.userList);//Пользователи

    const [projectSelected, setProjectSelected] = useState(null);
    const [projectCount, setProjectCount] = useState(-1);

    const [loading, setLoading] = useState([{ id: 0, loading: false }, { id: 1, loading: false }, { id: 2, loading: false }, { id: 3, loading: false }, { id: 4, loading: false }, { id: 5, loading: false }, { id: 6, loading: false }]);

    function loadSet(id, val) {
        setLoading(loading_ => loading_.map(item => {
            if (item.id === id) {
                return { ...item, loading: val }
            }
            else {
                return item;
            }
        }))
    }
    function loadAllSet(val) {
        setLoading(loading_ => loading_.map(item => {
            return { ...item, loading: val }
        }))
    }

    //Загрузит в редюсер необходимые данные
    function stateBoardListLoad(id_project) {
        loadAllSet(true);
        //Загружаем таблицу с связкой доска-проект
        if (stateBoardProjectList.list_loaded.filter(a => a.id_project == id_project).length === 0) {
            axios.get('/api_tracker/board/projectList', { params: { ID_Project: id_project } })
                .then((res) => {
                    dispatch(loadBoardProjectList({ list: res.data.Data, id_project: id_project }))
                    loadSet(0, false);
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                    loadSet(0, false);
                });
        }
        else {
            loadSet(0, false);
        }
        //Загружаем доски
        if (stateBoardList.list_loaded === false) {
            if (id_project !== null) {
                axios.get('/api_tracker/board/list')
                    .then((res) => {
                        dispatch(loadBoard({ list: res.data.Data, id_project: id_project }))
                        loadSet(1, false);
                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                        loadSet(1, false);
                    });
            }
        }
        else {
            loadSet(1, false);
        }
        //Список доступных пользователей доски
        if (stateBoardProjectList.list_loaded_user.filter(a => a.id_project == id_project).length === 0) {
            axios.get('/api_tracker/board/projectUserAvailableList', { params: { ID_Project: id_project } })
                .then((res) => {
                    dispatch(loadBoardProjectUser({ list: res.data.Data, id_project: id_project }))
                    loadSet(2, false);
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                    loadSet(2, false);
                });
        }
        else {
            loadSet(2, false);
        }
        //Список доступных досок для перемещения
        if (stateBoardProjectList.list_loaded_transfer.filter(a => a.id_project == id_project).length === 0) {
            axios.get('/api_tracker/board/projectTransferAvailableList', { params: { ID_Project: id_project } })
                .then((res) => {
                    dispatch(loadBoardProjectTransfer({ list: res.data.Data, id_project: id_project }))
                    loadSet(3, false);
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                    loadSet(3, false);
                });
        }
        else {
            loadSet(3, false);
        }
        //Задачи с необходимыми данными
        if (stateBoardTaskList.list_loaded.filter(a => a.id_project == id_project).length === 0) {
            if (id_project !== null) {
                //Загружаем задачи
                axios.get('/api_tracker/board/taskList', { params: { ID_Project: id_project, Archive: false } })
                    .then((res) => {
                        dispatch(loadBoardTask({ list: res.data.Data, id_project: id_project }))
                        loadSet(4, false);
                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                        loadSet(4, false);
                    });
                //Подгружаем метки
                axios.get('/api_tracker/board/taskWidgetLabelListByProject', { params: { ID_Project: id_project } })
                    .then((res) => {
                        dispatch(loadListLabel({ list: res.data.Data, id_project: id_project }));
                        loadSet(5, false);
                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                        loadSet(5, false);
                    });
                //Подгружаем чек-листы
                axios.get('/api_tracker/board/taskWidgetChecklistListByProject', { params: { ID_Project: id_project } })
                    .then((res) => {
                        dispatch(loadCheckList({ list: res.data.Data, id_project: id_project }));
                        loadSet(6, false);
                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                        loadSet(6, false);
                    });
            }
        }
        else {
            loadSet(4, false);
            loadSet(5, false);
            loadSet(6, false);
        }
    }

    useEffect(() => {
        if (stateSetting.user !== null) {
            const companySelected = stateSetting.user.ID_Company_Selected;//Выбранная компания

            /***********************START ВЫБОР ПРОЕКТА************************/
            //Записываем проект выбранный по умолчанию в Local Storage
            const storage = JSON.parse(localStorage.getItem('board_project_selected'));

            var board_project_selected = [];

            //Если значение пустое, то добавляем первый попавшийся проект
            if (storage !== null) {
                board_project_selected = storage;

                //Если нет компании, то добавляем значение
                if (board_project_selected.filter(a => a.id_company === companySelected).length > 0) {
                    const project_selected = board_project_selected.filter(a => a.id_company === companySelected)[0].id_project;
                    setProjectSelected(project_selected);
                    handlerProjectClick(project_selected);
                }
            }
            /************************END ВЫБОР ПРОЕКТА*************************/
        }

    }, [stateSetting.user]);

    useEffect(() => {
        if (stateBoardTaskList.updatedBoard) {

            axios.post('/api_tracker/board/taskOrderChangeMass', { ID_Project: projectSelected, Items: stateBoardTaskList.list.filter(a => a.ID_Project == projectSelected).map((item) => { return { ID: item.ID, Order: item.Order } }) })
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(updatedBoardFalse());
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }, [stateBoardTaskList.updatedBoard]);

    //Изменение доски
    function moveBoard({ dragIndex, hoverIndex, idProject }) {

    }

    //Событие клика по проекту
    function handlerProjectClick(id) {

        const companySelected = stateSetting.user.ID_Company_Selected;//Выбранная компания       
        const board_project_selected = JSON.parse(localStorage.getItem('board_project_selected'));

        if (board_project_selected === null) {
            localStorage.setItem('board_project_selected', JSON.stringify([{ id_company: companySelected, id_project: id }]));
        }
        else {
            localStorage.setItem('board_project_selected', JSON.stringify([...board_project_selected.filter(a => a.id_company !== companySelected), { id_company: companySelected, id_project: id }]));
        }

        //Загружаем список досок в редюсер
        stateBoardListLoad(id);
        setProjectSelected(id);
    }

    /*******************************START ФИЛЬТР ПРОЕКТОВ***************************************/
    const [projectList, setProjectList] = useState([]);


    useEffect(() => {
        /*id - ИД проекта
                   name - Название проекта
                   count - Кол-во элементов в проекте  
         */

        if (stateProject.listLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listObjectLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listUserLoaded.filter(a => a.id_status === 1).length > 0
            & idObject != null & stateSetting.user != null & stateSetting.companyService != null) {

            const projects = ProjectForUserObjectList(stateProject.list, stateProject.listObject, stateProject.listUser, idObject, stateSetting.user.ID, stateSetting.companyService.ID_Role).map(item => {
                return { id: item.ID, name: item.Name }
            })

            setProjectList(prev => projects);

            setFilterLabelSelected(projects.map(item => {
                return { id_project: item.id, val: -1 }
            }))
            setFilterUserSelected(projects.map(item => {
                return { id_project: item.id, val: -1 }
            }))
        }
    }, [stateProject.list, stateProject.listObject, stateProject.listUser, stateSetting.companyService]);

    /********************************END ФИЛЬТР ПРОЕКТОВ****************************************/
    /*************************START ДОБАВЛЕНИЕ*********************************/
    const [boardModalAddShow, setBoardModalAddShow] = useState(false);

    /**************************END ДОБАВЛЕНИЕ**********************************/

    const [filterShow, setFilterShow] = useState(false);
    /***********************START ФИЛЬТР МЕТОК*********************************/
    const [filterLabelList, setFilterLabelList] = useState([]);
    const [filterLabelSelected, setFilterLabelSelected] = useState([]);

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем метки в нужный формат
        stateBoardTaskList.listLabel.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_Label & a.id_project === item.ID_Project).length == 0) {
                filter_list.push({ id: item.ID_Label, id_project: item.ID_Project, name: item.Name, color: item.Color, count: stateBoardTaskList.listLabel.filter(a => a.ID_Label === item.ID_Label & a.ID_Project === item.ID_Project).length })
            }
        })

        setFilterLabelList(filter_list);

    }, [stateBoardTaskList.listLabel]);

    function filterLabelHandler(id_label, id_project) {

        const val_ = filterLabelSelected.filter(a => a.id_project === id_project)[0].val === id_label ? -1 : id_label;

        const list = filterLabelSelected.map(item => {
            if (item.id_project === id_project) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterLabel({ id_project: id_project, id_label: val_ }));
        setFilterLabelSelected(list);
    }
    /************************END ФИЛЬТР МЕТОК**********************************/
    /********************START ФИЛЬТР ПОЛЬЗОВАТЕЛИ*****************************/
    const [filterUserList, setFilterUserList] = useState([]);
    const [filterUserSelected, setFilterUserSelected] = useState([]);

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем пользователей в нужный формат
        stateBoardTaskList.list.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_Responsible & a.id_project === item.ID_Project).length == 0) {
                const name_ = item.ID_Responsible === null ? 'Нет ответственного' : stateUserList.list.filter(a => a.ID_User === item.ID_Responsible).length > 0 ? stateUserList.list.filter(a => a.ID_User === item.ID_Responsible)[0].Name_User : 'Не найден...'
                filter_list.push({ id: item.ID_Responsible, id_project: item.ID_Project, name: name_, count: stateBoardTaskList.list.filter(a => a.ID_Responsible === item.ID_Responsible & a.ID_Project === item.ID_Project).length })
            }
        })

        setFilterUserList(filter_list);

    }, [stateBoardTaskList.list, stateUserList.list]);


    function filterUserHandler(id_user, id_project) {

        const val_ = filterUserSelected.filter(a => a.id_project === id_project)[0].val === id_user ? -1 : id_user;

        const list = filterUserSelected.map(item => {
            if (item.id_project === id_project) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }

        })
        dispatch(filterUser({ id_project: id_project, id_user: val_ }));
        setFilterUserSelected(list);
    }
    /*********************END ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ*****************************/

    return (
        <div className='admin_content'>
            <div ref={refHeader}>
                <div className="d-flex">
                    <FilterUniversal filterIcon={faDiagramProject} key={Math.random()} selected={projectSelected} list={projectList} clickHandler={handlerProjectClick} show_all={true} show_count={false} />
                    <div>
                        <button className={filterShow === true ? "m-tabbar-button-menu action active" : "m-tabbar-button-menu action"} onClick={() => setFilterShow(!filterShow)}>
                            <FontAwesomeIcon className="" icon={faFilter} />
                        </button>
                    </div>
                </div>
                {projectList.map(item => (
                    <div key={item.id} className={item.id !== projectSelected ? "d-none" : ""}>
                        <div className={filterShow === false ? "d-none" : ""}>
                            <div className="filter-container mt-10">
                                <div className="d-flex">
                                    <div className="filter-title"><FontAwesomeIcon icon={faFilter} />ФИЛЬТР</div>
                                    {filterLabelSelected.filter(a => a.id_project === item.id)[0].val != -1 &&
                                        <div className="text-danger" style={{ marginLeft: 'auto' }}>
                                            Перетаскивание задач отключено
                                        </div>
                                    }
                                </div>
                                <FilterUniversal filterName="Метки" filterIcon={faTag} list={filterLabelList.filter(a => a.id_project === item.id)} show_count={true} id_filter={item.id} clickHandler={filterLabelHandler} selected={filterLabelSelected.filter(a => a.id_project === item.id)[0].val} />
                                <FilterUniversal filterName="Ответственные" filterIcon={faUser} list={filterUserList.filter(a => a.id_project === item.id)} show_count={true} id_filter={item.id} clickHandler={filterUserHandler} selected={filterUserSelected.filter(a => a.id_project === item.id)[0].val} />
                            </div>
                        </div>
                    </div>
                ))}
                <BoardModalAdd show={boardModalAddShow} onHide={() => setBoardModalAddShow(false)} idProject={projectSelected} />
            </div>
            {projectCount === 0 && (
                <div className="alert alert-warning fs-5 mt-15" role="alert">
                    Для начала работы с досками необходимо в настройках хотя бы одного проекта указать «Использовать в досках»
                </div>
            )}
            {projectSelected === null ? (
                <div className="alert alert-warning fs-5 mt-15" role="alert">
                    Выберите проект
                </div>
            ) : (
                loading.filter(a => a.loading === true).length > 0 ? (
                    <div className="loader_01 mt-30"></div>
                ) : (
                    <div className="board_container">
                        {stateBoardProjectList.list.filter(a => a.ID_Project == projectSelected).sort((a, b) => a.Order - b.Order).map((model, index) => (
                            stateBoardList.list.filter(a => a.ID == model.ID_Board).length > 0 && (
                                <BoardItem key={model.ID_Board + '_' + model.ID_Project} index={index} model={stateBoardList.list.filter(a => a.ID == model.ID_Board)[0]} moveBoard={moveBoard} projectSelected={projectSelected} refHeader={refHeader} />
                            )
                        ))}
                        {stateSetting.companyService !== null &&
                            stateSetting.companyService.ID_Role !== 2 && (
                                stateBoardProjectList.list.filter(a => a.ID_Project == projectSelected).length > 0 ? (
                                    <button className="board-add-button" style={{ width: '40px' }} onClick={() => setBoardModalAddShow(true)}>
                                        <FontAwesomeIcon className="" icon={faPlus} />
                                    </button>
                                ) :
                                    (
                                        <button className="board-add-button" onClick={() => { setBoardModalAddShow(true) }}>
                                            <FontAwesomeIcon className="" icon={faPlus} /> Добавить доску
                                        </button>
                                    )
                            )}
                    </div>
                )

            )}
        </div>
    )
}
export default Index;